import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { CreatePaywallSubscriptionFormContextProvider } from "@circle-react-shared/Paywalls/Modals/CreatePaywallSubscriptionModal/Form/CreatePaywallSubscriptionFormContextProvider";
import { BulkImportTrialPaywallSubscriptionFormContextProvider } from "./BulkImportTrialPaywallSubscriptionFormProvider";
import { BulkImportTrialPaywallSubscriptionForm } from "./index";

interface BulkImportTrialPaywallSubscriptionFormRailsViewProps {
  hide_notify_member_form?: boolean;
  paywall_coupon_code?: string;
  paywall_id?: string;
  paywall_price_id?: string;
  paywall_skip_date_validations?: boolean;
  paywall_trial_days?: string;
}

export const BulkImportTrialPaywallSubscriptionFormRailsView = ({
  paywall_id: paywallId,
  paywall_price_id: paywallPriceId,
  paywall_trial_days: paywallTrialDays,
  paywall_coupon_code: paywallCouponCode,
  paywall_skip_date_validations: skipDateValidations = true,
  hide_notify_member_form: hideNotifyMemberForm = false,
}: BulkImportTrialPaywallSubscriptionFormRailsViewProps) => (
  <QueryClientProvider>
    <CreatePaywallSubscriptionFormContextProvider>
      <BulkImportTrialPaywallSubscriptionFormContextProvider
        {...{
          paywallId: paywallId ? Number(paywallId) : undefined,
          paywallPriceId: paywallPriceId ? Number(paywallPriceId) : undefined,
          paywallTrialDays: paywallTrialDays
            ? Number(paywallTrialDays)
            : undefined,
          paywallCouponCode,
          skipDateValidations,
          hideNotifyMemberForm,
        }}
      >
        <BulkImportTrialPaywallSubscriptionForm />
      </BulkImportTrialPaywallSubscriptionFormContextProvider>
    </CreatePaywallSubscriptionFormContextProvider>
  </QueryClientProvider>
);
